import httpClient from './httpClient';

const END_POINT = '/api/countries';

const getAllCountries = (perPage = null, page = null, sort = null, filterList = '') => {
    let countryApi = END_POINT;
    countryApi += filterList != '' ? '?' + filterList : '';
    countryApi += filterList == '' && perPage != null ? `?itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    countryApi += filterList != '' && perPage != null ? `&itemsPerPage= ${perPage} &page= ${page} ${sort}` : '';
    return httpClient.get(countryApi);
};

const deleteCountry = id => httpClient.delete(END_POINT + '/' + id);
const addCountry = country => httpClient.post(END_POINT, country);
const updateCountry = (id, country) =>
    httpClient.put(END_POINT + '/' + id, country);
const getAllCountriesJson = () => httpClient.get(END_POINT + '.json');

export {
    getAllCountries,
    getAllCountriesJson,
    deleteCountry,
    addCountry,
    updateCountry
};
